import React, { useState, useEffect } from 'react';
import { Progress, Col, Row, Button } from 'reactstrap';
import { faPlus, faMinus, faLongArrowAltDown, faLongArrowAltUp, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const RiskReturnExpectation = ({ nextStep, prevStep, active, processing, investAccount }) => {
    const [riskReturnExpectation, setRiskReturnExpectation] = useState(5);

    useEffect(() => {
        if (active && investAccount && investAccount.id) {
            setRiskReturnExpectation(investAccount.risk_return_expectation || 5);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [active, investAccount]);

    const handleSubmit = () => {
        nextStep({ risk_return_expectation: riskReturnExpectation });
    };

    return (
        <div className={`account-setup-wrapper ${!active ? 'd-none' : ''}`}>
            <div className="form-container">
                <div className="back-btn">
                    <Button color="link" onClick={() => prevStep()}>back</Button>
                </div>
                <div className="form-header mt-md-3 mt-0">
                    <h2>RISK-RETURN EXPECTATION</h2>
                    <span>Help us understand your risk-return expectation.</span>
                </div>
                <div className="account-info-container">
                    <div className="risk-return-wrapper">
                        <div className="negative_risk"><span>-{riskReturnExpectation}%</span><FontAwesomeIcon icon={faLongArrowAltDown} /></div>
                        <span className="line"></span>
                        <div className="positive_risk"><FontAwesomeIcon icon={faLongArrowAltUp} /><span>+{riskReturnExpectation}%</span></div>
                    </div>
                    <Row className="align-items-center">
                        <Col sm={1} xs={3}>
                            <button className="btn btn-outline-primary"
                                disabled={riskReturnExpectation <= 5}
                                onClick={() => setRiskReturnExpectation(riskReturnExpectation - 5)}>
                                <FontAwesomeIcon icon={faMinus} />
                            </button>
                        </Col>

                        <Col sm={10} xs={6}>
                            <Progress multi>
                                <Progress color="transparent" bar value={16.67 * (riskReturnExpectation / 5)} />
                                <Progress bar value="10" />
                            </Progress>
                        </Col>
                        <Col sm={1} xs={3}>
                            <button className="btn btn-outline-primary"
                                disabled={riskReturnExpectation === 30}
                                onClick={() => setRiskReturnExpectation(riskReturnExpectation + 5)}>
                                <FontAwesomeIcon icon={faPlus} />
                            </button>
                        </Col>
                    </Row>
                </div>
                <div className="button_wrapper">
                    <button className="custom-btn-primary" type="button" onClick={() => handleSubmit()} disabled={processing}>
                        NEXT QUESTION {processing && <FontAwesomeIcon icon={faSpinner} spin />}
                    </button>
                </div>
            </div>
        </div>
    )
};

export default RiskReturnExpectation
